import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  EmptyDisbursementModuleList,
  analyticsGrey,
  analyticsIcon,
} from "../../../assets/images";
import { GetDisbursementPayloadType } from "../../../commonTypes/disbursementsTypes";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import {
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
} from "../../../components/commons";
import MultiSelect from "../../../components/commons/MultiSelect";
import { SearchIcon } from "../../../components/Icon";
import { resetSession } from "../../../redux/auth";
import {
  getDisbursementsListAction,
  getSharedDisbursementsListAction,
  resetDisbursementList,
  resetDisbursementsError,
  resetDisbursementsMessage,
  resetDisbursementsStatusCode,
  resetDisbursementsSuccess,
  resetRemainingAmount,
  resetSharedDisbursementList,
  resetSingleDisbursement,
  resetTotalAmount,
  resetTotalCount,
  resetTotalSharedCount,
} from "../../../redux/disbursements";
import { DisbursementsListType } from "../../../redux/disbursements/disbursementsType";
import { RootState } from "../../../redux/rootReducers";
import {
  settingApproval,
  settingAttachment,
} from "../../../utils/invoiceGeneration";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import DisbursementTableData from "./DisbursementTableData";
import TableLoader from "../../AkTable/TableLoader";
import {
  APPROVAL_RADIO_OPTIONS,
  ATTACHMENT_RADIO_OPTIONS,
} from "../../InvoiceGeneration/Filter.tsx/Filter";
import DisbursementFilter from "../DisbursementFilter";
import PaymentSorting from "../../InvoiceGeneration/PaymentSorting/PaymentSorting";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import DisbursmentPieChart from "./PieChart/DisbursmentPieChart";
import ScrollToTop from "../../commons/ScrollToTop";
import { DISBURSEMENT_FILTER_PAYMENT_FORMAT } from "../../../constant/disbursementConst";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

interface TabsType {
  name: string;
  label: string;
}

type AppProps = {
  history?: any;
  token: string | null;
  message: string | null;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  search_value?: string | null | undefined;
  error: string | null;
  success: number | null;
  statusCode: number | null;
  fetching: boolean;
  totalAmount: number;
  remainingAmount: number;
  disbursementModuleList?: [] | DisbursementsListType[];
  sharedDisbursementList: [] | DisbursementsListType[];
  totalSharedCount: number;
  dispatchResetDisbursementsSuccess: () => void;
  dispatchResetDisbursementsError: () => void;
  dispatchResetDisbursementsMessage: () => void;
  dispatchResetDisbursementsStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetSharedDisbursementCount: () => void;
  dispatchResetSingleDisbursement: () => void;
  dispatchResetSharedDisbursementList: () => void;
  dispatchResetTotalAmount: () => void;
  dispatchResetRemainingAmount: () => void;
  dispatchGetSharedDisbursementsListAction: (
    data: GetDisbursementPayloadType
  ) => void;
  tableHeader: [] | TableHeadersType[];
  handleEditDisbursementData: (data: any) => void;
  handleSearch?: (data: any) => void;
  searchData?: string;
  activeTab: string;
};
const SharedDisbursementList = ({
  history,
  token,
  statusCode,
  success,
  message,
  fetching,
  error,
  totalAmount,
  remainingAmount,
  dispatchResetDisbursementsSuccess,
  dispatchResetTotalAmount,
  dispatchResetRemainingAmount,
  dispatchResetDisbursementsError,
  dispatchResetDisbursementsMessage,
  dispatchResetDisbursementsStatusCode,
  dispatchResetSession,
  dispatchGetSharedDisbursementsListAction,
  dispatchResetSingleDisbursement,
  dispatchResetSharedDisbursementCount,
  dispatchResetSharedDisbursementList,
  sharedDisbursementList,
  totalSharedCount,
  tableHeader,
  disbursementModuleList,
  handleEditDisbursementData,
  activeTab,
}: AppProps) => {
  const tabs: TabsType[] = [
    {
      name: "Disbursements List",
      label: "Disbursements_list",
    },
    {
      name: "Shared With Me",
      label: "shared_with_me",
    },
  ];

  const persistDisbursementSearchData = history?.location?.state?.searchData;
  const [searchData, setSearchData] = useState(persistDisbursementSearchData);
  const [attachment, setAttachment] = useState<string>("");
  const [approved, setApproved] = useState<string>("");
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [approvalValue, setApprovalValue] = useState<string>("");
  const [attachmentValue, setAttachmentValue] = useState<string>("");
  const [data, setData] = useState<any[]>([]);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);
  const [disbursementSharedData, setDisbursementSharedData] = useState<
    DisbursementsListType[] | []
  >([]);
  const [isMultiSelectPresent, setIsMultiSelectPresent] =
    useState<boolean>(false);
  const [paymentStatus, setPaymentStatus] = useState("");
  const [allPaymentStatus, setAllPaymentStatus] = useState<number[]>([]);
  const [isPieChartVisible, setIsPieChartVisible] = useState<boolean>(true);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const persistApproval = history?.location?.state?.approvalValue;
  const persistAttachment = history?.location?.state?.attachmentValue;
  const persistAllPaymentStatus = history?.location?.state?.allPaymentStatus;

  //====================User Management=============================
  const [isEditDisbursementPresent, setIsEditDisbursementPresent] =
  useMenuCheck();
//=================================================================

useEffect(()=>{
  setIsEditDisbursementPresent("Edit Disbursement Module", "menu")
},[])

  useEffect(() => {
    if (allPaymentStatus?.length != 4) {
      dispatchResetSharedDisbursementCount();
    }
    if (allPaymentStatus?.includes(10)) {
      setPaymentStatus("");
    } else {
      setPaymentStatus(allPaymentStatus.join(","));
    }
  }, [allPaymentStatus]);

  useEffect(() => {
    if (persistAllPaymentStatus?.length > 0) {
      let newActiveStatus = persistAllPaymentStatus.join(",")?.toString();
      setAllPaymentStatus(persistAllPaymentStatus);
      setPaymentStatus(newActiveStatus);
      setIsMultiSelectPresent(true);
      getData();
    }
  }, [persistAllPaymentStatus]);

  useEffect(() => {
    dispatchResetTotalAmount();
    dispatchResetRemainingAmount();
    dispatchResetDisbursementsSuccess();
    dispatchResetDisbursementsError();
    dispatchResetDisbursementsMessage();
    dispatchResetDisbursementsStatusCode();
    dispatchResetSingleDisbursement();
    dispatchResetSharedDisbursementCount();
    dispatchResetSharedDisbursementList();
    setDisbursementSharedData([]);
    setPaymentStatus("");
    setApproved("");
    setAttachment("");
  }, []);

  useEffect(() => {
    if (sharedDisbursementList?.length === 0) {
      setDisbursementSharedData([...sharedDisbursementList]);
    }

    if (offset === 0) {
      setDisbursementSharedData([...sharedDisbursementList]);
    } else if (offset > 0 && !fetching) {
      setDisbursementSharedData((prv: any) => [
        ...prv,
        ...sharedDisbursementList,
      ]);
    } else {
      setDisbursementSharedData([...sharedDisbursementList]);
    }
  }, [sharedDisbursementList]);

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (
      offset < +totalSharedCount &&
      !fetching &&
      Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
    ) {
      if (sharedDisbursementList?.length > 0) {
        if (!fetching && offset < +totalSharedCount) {
          setOffset(offset + limit);
        }
      }
    }
  };

  useEffect(() => {
    if (token) {
      const finalData = {
        token,
        limit,
        offset,
        attachment,
        approved,
        search_value: searchData,
        paymentStatus: paymentStatus
          ? paymentStatus
          : persistAllPaymentStatus
          ? `${[...persistAllPaymentStatus]}`
          : "",
      };

      if (offset < +totalSharedCount) {
        dispatchGetSharedDisbursementsListAction(finalData);
      } else if (offset === 0 && +totalSharedCount === 0) {
        dispatchResetSharedDisbursementList();
        setDisbursementSharedData([]);
        dispatchGetSharedDisbursementsListAction(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [sharedDisbursementList]);

  useEffect(() => {
    if (clearFilter) {
      if (token) {
        const finalData = {
          token,
          limit,
          offset,
          attachment,
          approved,
          search_value: searchData,
          paymentStatus,
        };
        dispatchGetSharedDisbursementsListAction(finalData);
      }
    }
  }, [clearFilter]);

  useEffect(() => {
    if (!searchData) {
      setOffset(0);
    }
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        if (searchData) {
          if (token) {
            const finalData = {
              token,
              attachment: attachment ? attachment : persistAttachment,
              offset: 0,
              approved: approved ? approved : persistApproval,
              search_value: searchData
                ? searchData
                : persistDisbursementSearchData,
              paymentStatus: paymentStatus
                ? paymentStatus
                : persistAllPaymentStatus
                ? `${[...persistAllPaymentStatus]}`
                : "",
            };
            dispatchGetSharedDisbursementsListAction(finalData);
          }
          setDisbursementSharedData([]);
        }
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchData]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (value?.length === 0) {
      const finalData = {
        token,
        limit,
        offset: 0,
        attachment: attachment ? attachment : persistAttachment,
        approved: approved ? approved : persistApproval,
        paymentStatus: paymentStatus
          ? paymentStatus
          : persistAllPaymentStatus
          ? `${[...persistAllPaymentStatus]}`
          : "",
      };
      dispatchGetSharedDisbursementsListAction(finalData);
    }
  };

  useEffect(() => {
    dispatchResetSharedDisbursementCount();
    dispatchResetSharedDisbursementList();
    setDisbursementSharedData([]);
    getData();
    setOffset(0);
    setIsMultiSelectPresent(true);
    if (
      (attachment && isMultiSelectPresent) ||
      (approved && isMultiSelectPresent) ||
      (!approved && isMultiSelectPresent) ||
      (!attachment && isMultiSelectPresent)
    ) {
      if (offset === 0 && totalSharedCount == 0) {
        let finalData = {
          token,
          limit,
          offset,
          search_value: searchData,
          attachment,
          approved,
          paymentStatus: paymentStatus
            ? paymentStatus
            : persistAllPaymentStatus
            ? `${[...persistAllPaymentStatus]}`
            : "",
        };

        dispatchGetSharedDisbursementsListAction(finalData);
      }
    }
  }, [attachment, approved, paymentStatus, applyFilter]);

  const getData = useCallback(() => {
    const getAttachmentValue = ATTACHMENT_RADIO_OPTIONS.find(
      (item: RadioTypes) => item.id === attachment
    );
    const getApprovedValue = APPROVAL_RADIO_OPTIONS.find(
      (item: RadioTypes) => item.id === approved
    );
    const getPaymentValue = DISBURSEMENT_FILTER_PAYMENT_FORMAT?.filter(
      (el: any, index: number) => {
        if (allPaymentStatus?.includes(+el?.value) && el?.value != 10) {
          return el;
        }
      }
    );
    if (getPaymentValue?.length === 0) {
      setMultiSelectData([getAttachmentValue, getApprovedValue, undefined]);
    } else {
      let allStatusValues = allPaymentStatus?.includes(10);
      if (allStatusValues) {
        setMultiSelectData([getAttachmentValue, getApprovedValue]);
      } else {
        setMultiSelectData([
          getAttachmentValue,
          getApprovedValue,
          ...getPaymentValue,
        ]);
      }
    }
  }, [attachment, approved, paymentStatus]);

  // persists filter
  useEffect(() => {
    if (persistApproval?.length > 0 || persistAttachment?.length > 0) {
      setApproved(persistApproval);
      setAttachment(persistAttachment);
      setApprovalValue(persistApproval);
      setAttachmentValue(persistAttachment);
    }
  }, [persistApproval, persistAttachment]);

  const onClose = (id: any) => {
    let newid = id.split("_")[0];
    if (newid === "Att") {
      delete history?.location?.state?.attachmentValue;
    }
    if (newid === "App") {
      delete history?.location?.state?.approvalValue;
    }
    if (id === "payment4" || id === "payment3" || id === "payment2") {
      delete history?.location?.state?.allPaymentStatus;
    }
    dispatchResetSharedDisbursementCount();
    resetSharedDisbursementList();
    setDisbursementSharedData([]);
    const checkAttachmentValue = ATTACHMENT_RADIO_OPTIONS.find(
      (item: RadioTypes) => item._id === id
    );
    const checkApprovedValue = APPROVAL_RADIO_OPTIONS.find(
      (item: RadioTypes) => item._id === id
    );
    const checkPaymentValue = DISBURSEMENT_FILTER_PAYMENT_FORMAT?.find(
      (item: any) => item?._id === id
    );

    if (checkAttachmentValue) {
      setAttachment("");
      setAttachmentValue("");
    }
    if (checkApprovedValue) {
      setApproved("");
      setApprovalValue("");
    }
    if (checkPaymentValue) {
      const removePaymentValue = allPaymentStatus?.filter(
        (item: any) => item != checkPaymentValue?.value
      );
      setAllPaymentStatus([...removePaymentValue]);
    }
  };

  const editDisbursementData = (data: any) => {
    handleEditDisbursementData({
      data,
      attachmentValue,
      approvalValue,
      searchData,
      allPaymentStatus,
      paymentStatus,
    });
  };
  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetDisbursementsError();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      {
        <div>
          <div
            className="col-md-12 text-right d-flex flex-row"
            style={{
              justifyContent: "flex-end",
              padding: "10px",
              backgroundColor: "#fff",
            }}
          >
            <div className="col-md-5 flex-start" style={{ padding: 0 }}>
              <div
                className="d-flex flex-column"
                style={{ justifyContent: "center", alignItems: "flex-start" }}
              >
                <div className="flex-center" style={{ gap: "5px" }}>
                  <div style={{ fontSize: "18px", fontWeight: 500 }}>
                    Shared Disbursement List
                  </div>
                  <div
                    onClick={() => setIsPieChartVisible(!isPieChartVisible)}
                    className="flex-center show-hide-btn-head"
                  >
                    {
                      <div
                        className="show-hide-btn"
                        style={
                          isPieChartVisible
                            ? {
                                border: "1px solid #dd4433",
                                backgroundColor: "#fff6f5",
                              }
                            : { border: "1px solid #262a44" }
                        }
                      >
                        <img
                          src={
                            isPieChartVisible ? analyticsIcon : analyticsGrey
                          }
                          alt=""
                        />
                        <div
                          style={
                            isPieChartVisible
                              ? { color: "#dd4433" }
                              : { color: "#262a44" }
                          }
                        >
                          {isPieChartVisible ? "Hide Summary" : "Open Summary"}
                        </div>
                      </div>
                    }
                  </div>
                </div>
                {!fetching && (
                  <div
                    style={{
                      color: "rgb(124, 141, 176)",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    Total {totalSharedCount ? totalSharedCount : 0} entries
                    found
                  </div>
                )}
              </div>

              <MultiSelect data={multiSelectData} onClose={onClose} />
            </div>
            <div className="col-md-7 d-flex justify-content-end">
              <div className="mr-1">
                <PaymentSorting
                  setAllPaymentStatus={setAllPaymentStatus}
                  allPaymentStatus={allPaymentStatus}
                  options={DISBURSEMENT_FILTER_PAYMENT_FORMAT}
                />
              </div>
              <div className="mr-1">
                <DisbursementFilter
                  attachment={attachment}
                  approved={approved}
                  settingApproval={settingApproval}
                  settingAttachment={settingAttachment}
                  setAttachment={setAttachment}
                  setApproved={setApproved}
                  setClearFilter={setClearFilter}
                  setOffset={setOffset}
                  approvalValue={approvalValue}
                  attachmentValue={attachmentValue}
                  setApprovalValue={setApprovalValue}
                  setAttachmentValue={setAttachmentValue}
                  setData={setData}
                  setDataReset={setDisbursementSharedData}
                  resetCount={dispatchResetSharedDisbursementCount}
                  setApplyFilter={setApplyFilter}
                />
              </div>
              <div
                className="col-md-6 position-relative"
                style={{ marginRight: "-29px", marginLeft: "-10px" }}
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchData}
                />
              </div>
            </div>
          </div>

          <div>
            {isPieChartVisible && (
              <DisbursmentPieChart
                totalAmount={totalAmount}
                remainingAmount={remainingAmount}
              />
            )}
          </div>

          {fetching && offset === 0 ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : sharedDisbursementList?.length > 0 ? (
            <div className="table-bordered" style={{ overflowX: "scroll" }}>
              <table className="table table-striped">
                <thead className="text-center sticky-table-header">
                  <TableHeader tableHeader={tableHeader} />
                </thead>
                <tbody>
                  <DisbursementTableData
                    tableHeader={tableHeader}
                    disbursementModuleList={disbursementSharedData}
                    handleEditDisbursementData={editDisbursementData}
                    isEditDisbursementPresent={isEditDisbursementPresent}
                  />
                </tbody>
              </table>
            </div>
          ) : (
            <div className="mt-5">
              <EmptyListPage
                title="No Disbursements List Found!"
                image={EmptyDisbursementModuleList}
                imageWidth="30%"
                showLinkButton={false}
                showAddButton={false}
              />
            </div>
          )}
          {handleErrorModal()}
          {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </div>
      }
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.disbursements.fetching,
  error: state.disbursements.error,
  success: state.disbursements.success,
  message: state.disbursements.message,
  statusCode: state.disbursements.statusCode,
  disbursementModuleList: state.disbursements.disbursementsList,
  sharedDisbursementList: state.disbursements.sharedDisbursementList,
  totalSharedCount: state.disbursements.totalSharedCount,
  totalAmount: state.disbursements.totalAmount,
  remainingAmount: state.disbursements.remainingAmount,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetSharedDisbursementsListAction: (
    data: GetDisbursementPayloadType
  ) => dispatch(getSharedDisbursementsListAction(data)),
  dispatchResetDisbursementsSuccess: () =>
    dispatch(resetDisbursementsSuccess()),
  dispatchResetDisbursementsError: () => dispatch(resetDisbursementsError()),
  dispatchResetDisbursementsMessage: () =>
    dispatch(resetDisbursementsMessage()),
  dispatchResetDisbursementsStatusCode: () =>
    dispatch(resetDisbursementsStatusCode()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSingleDisbursement: () => dispatch(resetSingleDisbursement()),
  dispatchResetSharedDisbursementList: () =>
    dispatch(resetSharedDisbursementList()),
  dispatchResetSharedDisbursementCount: () => dispatch(resetTotalSharedCount()),
  dispatchResetTotalAmount: () => dispatch(resetTotalAmount()),
  dispatchResetRemainingAmount: () => dispatch(resetRemainingAmount()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SharedDisbursementList);
